export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <a href="#hero" className="footer-logo">
          <img
            src={`${process.env.PUBLIC_URL}/images/logo-green.png`}
            alt="SAFE"
            className="footer-logo-img"
          />
        </a>
        <nav className="footer-nav">
          <a href="#terms">Conditions d&apos;utilisation</a>
          <a href="#privacy">Vie privée</a>
          <a href="#contact">Contact</a>
        </nav>
        <p className="footer-copy">© Safe 2023. Tous droits réservés.</p>
      </div>
    </footer>
  );
}
